<template>
  <div class="index">
    <!-- banner轮播图 -->
    <div class="carousel-banner">
      <div v-for="(item, index) in banners" :key="index" class="carousel">
        <img v-if="bannerIndex == index" :src="item" class="banner"/>
      </div>
      <div class="flex-center">
        <div class="flex-row carousel-anchor">
          <div v-for="(item, idx) in banners" :key="idx" @click="changeBanner(idx)"
              class="anchor" :style="bannerIndex == idx ? 'opacity: 0.75;' : 'opacity: 0.25;'"/>
        </div>
      </div>
    </div>

    <!-- 家友理念 -->
    <div id="concept" class="flex-col align-center module" :class="{ visible: visibleModules['concept'] }" style="margin-top: 40px">
      <p class="title">{{$t('Index.Concept.title')}}</p>
      <p class="content">{{$t('Index.Concept.content')}}</p>
      <!-- <el-image class="display-pic" src="/static/img/index/concept.jpg" /> -->
      <video class="display-video" controls muted autoplay playsinline loop poster="/static/img/index/caseshow.jpg" >
        <source src="/static/img/index/eco_home.mp4" type="video/mp4">
      </video>
    </div>

    <!-- 定制 -->
    <div id="customization" class="flex-col align-center module" style="margin-top: 10px;" :class="{ visible: visibleModules['customization'] }">
      <el-image class="display-pic" src="/static/img/index/customization.jpg" />
    </div>

    <!-- 色系 -->
    <!-- <div id="colors" class="flex-col align-center module" :class="{ visible: visibleModules['colors'] }">
      <p class="title">{{$t('Index.Colors.title')}}</p>
      <p class="content">{{$t('Index.Colors.content')}}</p>
      <el-image class="display-pic" src="/static/img/index/colors.jpg" />
    </div> -->

    <!-- 家居空间 -->
    <div id="case" class="flex-col align-center module case-show" :class="{ visible: visibleModules['case'] }">
      <p class="title">{{$t('Index.Case.title')}}</p>
      <p class="content">{{$t('Index.Case.content')}}</p>
      <div class="showcase-item" :style="{ backgroundImage: 'url(/static/img/index/concept.jpg)' }" @click="goProduct()">
        <!-- <div class="showcase-overlay">
          <div class="showcase-content">
            <h3 class="showcase-title">家居空间</h3>
            <p class="showcase-subtitle">HOME CASE SHOW</p>
            <div class="flex-center">
              <button class="showcase-button" @click="goProduct()">{{ lang == 'en' ? 'Read More' : '了解更多'}} </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import pubsub from 'pubsub-js'

export default {
  data() {
    return {
      lang: localStorage.getItem('lindemanLocaleLanguage') ? localStorage.getItem('lindemanLocaleLanguage') : 'zh',

      timtiming: null,
      bannerIndex: 0,
      banners: [
        "/static/img/banner0.jpg", 
        "/static/img/banner1.jpg", 
        "/static/img/banner2.jpg", 
        "/static/img/banner3.jpg", 
        "/static/img/banner4.jpg", 
        "/static/img/banner5.jpg", 
        "/static/img/banner6.jpg", 
        "/static/img/banner7.jpg"
      ],

      observer: null,
      visibleModules: {}
    }
  },

  mounted() {
    document.documentElement.scrollTop = 0
    
    // 开启banner定时轮播
    this.timer()

    // 订阅消息
    this.pid = pubsub.subscribe('lindemanLocaleLanguage', (msgName, data) => { this.lang = data }) 

    this.setupScrollAndLazyLoad()
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    clearInterval(this.timing)
    pubsub.unsubscribe(this.pid)

    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener('scroll', this.handleScroll)
  },

  watch: {
    $route(to, from){
      if(to.query.key != from.query.key){
        document.documentElement.scrollTop = 0
      }
    }
  },
  
  methods:{
    // 定时切换banner
    timer() {
      clearInterval(this.timing)
      this.timing = setInterval(() => {
        let bannerIndex = this.bannerIndex + 1
        if(bannerIndex > this.banners.length - 1){
          bannerIndex = 0
        }
        this.changeBanner(bannerIndex)
      }, 6000)
    },

    // 点击轮播图底部锚点切换banner
    changeBanner(idx){
      this.bannerIndex = idx
    },

    setupScrollAndLazyLoad() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // 处理懒加载动画
          if (entry.target.classList.contains('module')) {
            if (entry.isIntersecting) {
              this.$set(this.visibleModules, entry.target.id, true)
            }
          }
        })
      }, options)

      document.querySelectorAll('.module').forEach(section => {
        if (section) this.observer.observe(section)
      })
    },

    // 跳转关于我们详情页
    goAboutUs(){
      this.$router.push('about')
    },
    
    // 跳转产品中心家居空间
    goProduct(){
      this.$router.push({
          path: 'product',
          query: {
            key: Math.random()
          }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../static/css/mobile/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/mobile/Index.vue